"use client";

import { useEffect, useState } from "react";
import { FileText, Calculator, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TransformezVotreMaisonEnTouteSimplicite() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: subtitleRef,
    isVisible: subtitleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.3;
  return <section className="relative w-full min-h-screen overflow-hidden bg-dark-background">
      {}
      <div id="devis"></div>
      
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/modern_home_renovation_individual_professional_journey.png)",
      transform: `translateY(${parallaxOffset}px)`,
      willChange: "transform"
    }} />
      
      {}
      <div className="absolute inset-0 bg-black/40" />

      {}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-16 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {}
          <div ref={titleRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "0ms"
        }}>
            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-tight">
              Des artisans qualifiés,des projets securisés
            </h1>
          </div>

          {}
          <div ref={subtitleRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${subtitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "200ms"
        }}>
            <p className="font-sans text-lg sm:text-xl text-white max-w-3xl mx-auto">
              be travaux simplifie la recherche d'artisans qualifiés pour tous vos projets
            </p>
          </div>

          {}
          <div ref={ctaRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "400ms"
        }}>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link to="https://betravaux.com/demande-de-devis/">
                  <Button id="btn-devis" size="lg" className="bg-[#f59e0b] text-white hover:bg-[#d97706] px-6 py-3 rounded-md font-medium shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0 w-full sm:w-auto">
                    <FileText className="mr-2" />
                    Demander un devis
                  </Button>
                </Link>
                
                <Link to="/AidesFinancieresPage">
                  <Button size="lg" className="bg-[#3b82f6] text-white hover:bg-[#2563eb] px-6 py-3 rounded-md font-medium shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0 w-full sm:w-auto">
                    <Calculator className="mr-2" />
                    Simuler mes aides
                  </Button>
                </Link>
                
                <Link to="https://betravaux.com/depannage/">
                  <Button size="lg" variant="outline" className="bg-white text-gray-800 border border-gray-200 hover:bg-gray-50 px-6 py-3 rounded-md font-medium shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0 w-full sm:w-auto">
                    <Clock className="mr-2" />
                    Découvrir en urgence
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}